// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/entity/geoentity.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_latlng } from "../core/latlng_pb";

/**
 * Describes the file proto/model/entity/geoentity.proto.
 */
export const file_proto_model_entity_geoentity = /*@__PURE__*/
  fileDesc("CiJwcm90by9tb2RlbC9lbnRpdHkvZ2VvZW50aXR5LnByb3RvEgZjYXJtZW4i0gMKBENpdHkSDwoHY2l0eV9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEiAKCGxvY2F0aW9uGAMgASgLMg4uY2FybWVuLkxhdExuZxIUCgxjb3VudHJ5X2NvZGUYBCABKAkSEQoJcmVnaW9uX2lkGAUgASgJEhIKCnBvcHVsYXRpb24YBiABKAMSEAoIdGltZXpvbmUYByABKAkSFQoNYWlycG9ydF9jb2RlcxgIIAMoCRIcChRkZWZhdWx0X2FpcnBvcnRfY29kZRgJIAEoCRIzCgxleHRlcm5hbF9pZHMYCiADKAsyHS5jYXJtZW4uQ2l0eS5FeHRlcm5hbElkc0VudHJ5EhMKC2FkbWluX2xldmVsGAsgASgJEhYKDnN0YXRlX3Byb3ZpbmNlGAwgASgJEhQKDGVuZ2xpc2hfbmFtZRgNIAEoCRIrCgdjcmVhdGVkGA4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghtb2RpZmllZBgPIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAaMgoQRXh0ZXJuYWxJZHNFbnRyeRILCgNrZXkYASABKAUSDQoFdmFsdWUYAiABKAk6AjgBIo0EChRBZG1pbmlzdHJhdGl2ZVJlZ2lvbhIRCglyZWdpb25faWQYASABKAkSDAoEbmFtZRgCIAEoCRIgCghsb2NhdGlvbhgDIAEoCzIOLmNhcm1lbi5MYXRMbmcSFAoMY291bnRyeV9jb2RlGAQgASgJEhIKCmlzb18zMTY2XzIYBSABKAkSFQoNcG9zdGFsX2FiYnJldhgGIAEoCRIMCgR0eXBlGAcgASgJEhUKDWFpcnBvcnRfY29kZXMYCCADKAkSHAoUZGVmYXVsdF9haXJwb3J0X2NvZGUYCSABKAkSQwoMZXh0ZXJuYWxfaWRzGAogAygLMi0uY2FybWVuLkFkbWluaXN0cmF0aXZlUmVnaW9uLkV4dGVybmFsSWRzRW50cnkSDwoHbmFtZV9lbhgLIAEoCRISCgpuYW1lX2xvY2FsGAwgASgJEhAKCG5hbWVfYWx0GA0gAygJEhAKCGFyZWFfa20yGA4gASgCEhEKCWFkbTFfY29kZRgPIAEoCRIrCgdjcmVhdGVkGBAgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghtb2RpZmllZBgRIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAaMgoQRXh0ZXJuYWxJZHNFbnRyeRILCgNrZXkYASABKAUSDQoFdmFsdWUYAiABKAk6AjgBIsMFCgdDb3VudHJ5EhIKCmNvdW50cnlfaWQYASABKAkSDAoEbmFtZRgCIAEoCRIMCgRpc28yGAMgASgJEgwKBGlzbzMYBCABKAkSEgoKcG9wdWxhdGlvbhgFIAEoAxIkCgljb250aW5lbnQYBiABKA4yES5jYXJtZW4uQ29udGluZW50EhUKDWN1cnJlbmN5X2NvZGUYByABKAkSFQoNY3VycmVuY3lfbmFtZRgIIAEoCRIYChBwcmltYXJ5X2xhbmd1YWdlGAkgASgJEhUKDWxhbmd1YWdlX2NvZGUYCiABKAkSFwoPY2FwaXRhbF9jaXR5X2lkGAsgASgJEhwKFGRlZmF1bHRfYWlycG9ydF9jb2RlGAwgASgJEjYKDGV4dGVybmFsX2lkcxgNIAMoCzIgLmNhcm1lbi5Db3VudHJ5LkV4dGVybmFsSWRzRW50cnkSDwoHZGVuc2l0eRgOIAEoAhIQCghhcmVhX2ttMhgPIAEoAhISCgptZWRpYW5fYWdlGBAgASgCEg8KB2dkcF91c2QYESABKAMSGAoQcHJpbWFyeV9yZWxpZ2lvbhgSIAEoCRIPCgdkZW1vbnltGBMgASgJEg8KB3dlYnNpdGUYFCABKAkSFAoMY2FsbGluZ19jb2RlGBUgASgJEgsKA3RsZBgWIAEoCRIpCgxkcml2aW5nX3NpZGUYFyABKA4yEy5jYXJtZW4uRHJpdmluZ1NpZGUSEQoJdW5fbWVtYmVyGBggASgIEisKB2NyZWF0ZWQYGSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKCG1vZGlmaWVkGBogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBoyChBFeHRlcm5hbElkc0VudHJ5EgsKA2tleRgBIAEoBRINCgV2YWx1ZRgCIAEoCToCOAEiXAoSR2VvRW50aXR5UmVmZXJlbmNlEhEKB2NpdHlfaWQYASABKAlIABITCglyZWdpb25faWQYAiABKAlIABIUCgpjb3VudHJ5X2lkGAMgASgJSABCCAoGZW50aXR5KrEBChBFeHRlcm5hbElkU3lzdGVtEiIKHkVYVEVSTkFMX0lEX1NZU1RFTV9VTlNQRUNJRklFRBAAEh8KG0VYVEVSTkFMX0lEX1NZU1RFTV9XSUtJREFUQRABEh8KG0VYVEVSTkFMX0lEX1NZU1RFTV9HRU9OQU1FUxACEhoKFkVYVEVSTkFMX0lEX1NZU1RFTV9PU00QAxIbChdFWFRFUk5BTF9JRF9TWVNURU1fRklQUxAEKtEBCglDb250aW5lbnQSGQoVQ09OVElORU5UX1VOU1BFQ0lGSUVEEAASFAoQQ09OVElORU5UX0FGUklDQRABEhgKFENPTlRJTkVOVF9BTlRBUkNUSUNBEAISEgoOQ09OVElORU5UX0FTSUEQAxIUChBDT05USU5FTlRfRVVST1BFEAQSGwoXQ09OVElORU5UX05PUlRIX0FNRVJJQ0EQBRIVChFDT05USU5FTlRfT0NFQU5JQRAGEhsKF0NPTlRJTkVOVF9TT1VUSF9BTUVSSUNBEAcqWgoLRHJpdmluZ1NpZGUSHAoYRFJJVklOR19TSURFX1VOU1BFQ0lGSUVEEAASFgoSRFJJVklOR19TSURFX1JJR0hUEAESFQoRRFJJVklOR19TSURFX0xFRlQQAiqDAQoNR2VvRW50aXR5S2luZBIfChtHRU9fRU5USVRZX0tJTkRfVU5TUEVDSUZJRUQQABIYChRHRU9fRU5USVRZX0tJTkRfQ0lUWRABEhoKFkdFT19FTlRJVFlfS0lORF9SRUdJT04QAhIbChdHRU9fRU5USVRZX0tJTkRfQ09VTlRSWRADQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_google_protobuf_timestamp, file_proto_model_core_latlng]);

/**
 * Describes the message carmen.City.
 * Use `create(CitySchema)` to create a new message.
 */
export const CitySchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geoentity, 0);

/**
 * Describes the message carmen.AdministrativeRegion.
 * Use `create(AdministrativeRegionSchema)` to create a new message.
 */
export const AdministrativeRegionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geoentity, 1);

/**
 * Describes the message carmen.Country.
 * Use `create(CountrySchema)` to create a new message.
 */
export const CountrySchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geoentity, 2);

/**
 * Describes the message carmen.GeoEntityReference.
 * Use `create(GeoEntityReferenceSchema)` to create a new message.
 */
export const GeoEntityReferenceSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geoentity, 3);

/**
 * Describes the enum carmen.ExternalIdSystem.
 */
export const ExternalIdSystemSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_geoentity, 0);

/**
 * ExternalIdSystem identifies the source of external identifiers for geographic entities.
 *
 * @generated from enum carmen.ExternalIdSystem
 */
export const ExternalIdSystem = /*@__PURE__*/
  tsEnum(ExternalIdSystemSchema);

/**
 * Describes the enum carmen.Continent.
 */
export const ContinentSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_geoentity, 1);

/**
 * Continent enumeration for countries.
 *
 * @generated from enum carmen.Continent
 */
export const Continent = /*@__PURE__*/
  tsEnum(ContinentSchema);

/**
 * Describes the enum carmen.DrivingSide.
 */
export const DrivingSideSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_geoentity, 2);

/**
 * DrivingSide indicates which side of the road vehicles drive on.
 *
 * @generated from enum carmen.DrivingSide
 */
export const DrivingSide = /*@__PURE__*/
  tsEnum(DrivingSideSchema);

/**
 * Describes the enum carmen.GeoEntityKind.
 */
export const GeoEntityKindSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_geoentity, 3);

/**
 * GeoEntityKind indicates the type of geographic entity.
 *
 * @generated from enum carmen.GeoEntityKind
 */
export const GeoEntityKind = /*@__PURE__*/
  tsEnum(GeoEntityKindSchema);

